import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/dealbuzzer_logo_icon_white.svg")